import i18next from "i18next";
import {initReactI18next} from "react-i18next";

// Import all languages files
import spanish from "./language/spanish.json";

const resources = {
    es: {
        translation: spanish,
    }
}

i18next
.use(initReactI18next)
.init({
    resources, 
    lng: "es" // default language
});

export default i18next;